import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import anime from 'animejs';

import { Text } from '../Text';
import { Button } from '../Button';
import { Secuence } from '../Secuence';

class Component extends React.Component {
  static displayName = 'Popup';

  static propTypes = {
    theme: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
    energy: PropTypes.object.isRequired,
    audio: PropTypes.object.isRequired,
    sounds: PropTypes.object.isRequired,
    className: PropTypes.any,
    message: PropTypes.string.isRequired,
    option: PropTypes.string.isRequired,
    onOption: PropTypes.func
  };

  enter () {
    const { energy } = this.props;

    anime({
      targets: this.element,
      easing: 'easeOutCubic',
      opacity: [0, 1],
      scale: [0.98, 1],
      duration: energy.duration.enter
    });
  }

  exit () {
    const { energy } = this.props;

    anime({
      targets: this.element,
      easing: 'easeInCubic',
      opacity: 0,
      scale: 0.98,
      duration: energy.duration.exit
    });
  }

  render () {
    const {
      theme,
      classes,
      energy,
      audio,
      sounds,
      className,
      message,
      option,
      onOption,
      ...etc
    } = this.props;

    return (
      <div
        className={cx(classes.root, className)}
        ref={ref => (this.element = ref)}
        {...etc}
      >
        <div className={classes.frame} />
        <div className={classes.main}>
          <Secuence>
            <div className={classes.message}>
              <Text
                audio={audio}
                animation={{ animate: energy.animate }}
              >
                {message}
              </Text>
            </div>
            <div className={classes.options}>
              <Button
                className={classes.option}
                audio={audio}
                animation={{ animate: energy.animate }}
                onClick={onOption}
              >
                {option}
              </Button>
            </div>
          </Secuence>
        </div>
      </div>
    );
  }
}

export { Component };

// Commit trace: 2025-08-28T05:28:12 - docs: update docstrings in Popup.js
